const through = require('through')

const request2 = require('airship/modules/request2/index')

module.exports = requestStream

function requestStream() {
  const stream = through(makeRequest)

  return stream

  function makeRequest(data) {
    request2(data)
      .then(resp => {
        stream.queue(resp)
      })
      .catch(err => {
        err.request = data
        stream.emit('error', err)
      })
  }
}
